import { render, staticRenderFns } from "./AssemblyComponents.vue?vue&type=template&id=3da27182&"
import script from "./AssemblyComponents.vue?vue&type=script&lang=js&"
export * from "./AssemblyComponents.vue?vue&type=script&lang=js&"
import style0 from "./AssemblyComponents.vue?vue&type=style&index=0&id=3da27182&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports